import React, { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

function Reset(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, seShowPassword] = useState(false);
  const [typeChange, setTypeChange] = useState('password');

  const passwordField1 = useRef('');
  const passwordField2 = useRef('');

  var url_string = window.location.href;
  var url = new URL(url_string);
  var token = url.searchParams.get('token');
  var onboard = url.searchParams.get('onboarding');

  if (token == undefined || token == null || token == '') {
    props.history.push('/login');
  }

  // handle button click of login form
  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    var a = passwordField1.current.value;
    var b = passwordField2.current.value;
    if (a != b) {
      setError("Those passwords didn't match");
      setLoading(false);
    } else if (a.length < 8) {
      setError('Password should be 8 characters or more');
      setLoading(false);
    } else {
      var obj = {
        token: token,
        password: a,
      };
      axios
        .post(process.env.REACT_APP_API_BASE_URL + 'passwordReset/confirm', obj)
        .then((r) => {
          localStorage.setItem('resetPass', 'true');
          setLoading(false);
          props.history.push('/login');
          toast.success('Password changed successfully');
        })
        .catch((r) => {
          setLoading(false);
          setError(
            'Something’s not right. Please check the link you clicked and try again.'
          );
        });
    }
  };

  const showPasswordHander = (e) => {
    e.preventDefault();
    if (showPassword) {
      seShowPassword(false);
      setTypeChange('password');
    } else {
      seShowPassword(true);
      setTypeChange('text');
    }
  };

  return (
    <body>
      <div class='container'>
        <div class='row'>
          <div class='col-sm-9 col-md-7 col-lg-6 mx-auto mt-4'>
            <div style={{ position: 'absolute', top: '-10px', right: '-80px' }}>
              <img
                alt='Kapitalwise'
                src={require('assets/img/login_top_back.svg')}
              />
            </div>
            <div
              class='card my-5 border border-1'
              style={{
                borderColor: '#A6ABC9',
                borderRadius: '20px',
                zIndex: '1',
              }}
            >
              <div class='card-body p-5'>
                <div className='d-flex justify-content-center align-items-center p-2'>
                  <img
                    alt='Kapitalwise'
                    src={require('assets/img/logo.svg')}
                    style={{ width: '3em', height: '3em' }}
                  />{' '}
                  <span className='nav_brand_text'>Kapitalwise</span>
                </div>
                <div className='login_title d-flex justify-content-center align-items-center p-2'>
                  <text>Enter your new password</text>
                </div>

                <form onSubmit={handleLogin}>
                  <div
                    class='form-floating mb-3'
                    style={{ lineHeight: '35px' }}
                  >
                    <text className='text-label-1'>New password</text>
                    <input
                      type='password'
                      class='form-control m-0'
                      id='floatingInput'
                      ref={passwordField1}
                    />
                  </div>
                  <div
                    class='form-floating mb-3'
                    style={{ lineHeight: '35px' }}
                  >
                    <div className='d-flex flex-wrap justify-content-between align-items-center'>
                      <text className='text-label-1'>Confirm password </text>
                    </div>

                    <div style={{ position: 'relative' }}>
                      <input
                        type={typeChange}
                        class='form-control m-0'
                        id='floatingPassword'
                        ref={passwordField2}
                      />
                      <span
                        className='input_icon'
                        style={{
                          position: 'absolute',
                          top: '0px',
                          right: '10px',
                        }}
                      >
                        {!showPassword ? (
                          // "show"
                          <i onClick={showPasswordHander} class='fas fa-eye'>
                            {' '}
                          </i>
                        ) : (
                          <i
                            onClick={showPasswordHander}
                            class='fas fa-eye-slash'
                          ></i>
                        )}{' '}
                      </span>{' '}
                    </div>
                  </div>
                  {error && (
                    <>
                      <small id='er' style={{ color: 'red' }}>
                        {error}
                      </small>
                      <br />
                    </>
                  )}
                  <div class='login_btn'>
                    <button class='xl_btn primary w_100 mt-2' type='submit'>
                      {loading ? 'Loading...' : 'Reset'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div style={{ position: 'absolute', bottom: '0px', left: '-40px' }}>
              <img
                alt='Kapitalwise'
                src={require('assets/img/login_bottom_back.svg')}
              />
            </div>
          </div>
        </div>
      </div>
    </body>
  );
}

export default Reset;
